import {useState} from "react";
import {useTranslation} from "react-i18next";
import {Box, Modal} from "@mui/material";
import CompaniesList from "../components/CompaniesList";
import CompanyForm from "../components/CompanyForm";
import {useAlert} from "../context/AlertContext";
import {ApiError} from "../types/api-errors";

const AdminCompaniesPage = () => {
    const {t} = useTranslation();
    const {showAlert} = useAlert();

    const [open, setOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const refreshCompanies = () => setRefresh((prev) => !prev);

    const handleCompanyAdded = () => {
        setOpen(false);
        refreshCompanies();
        showAlert(t("admincompanies.alerts.created"), "success");
    };

    const handleError = (error: ApiError | any) => {
        const msg =
            typeof error === "string"
                ? error
                : error?.message ?? t("admincompanies.errors.unexpected");

        showAlert(msg, "error");
    };

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <CompaniesList
                onAdd={() => setOpen(true)}
                refreshTrigger={refresh}
                refreshCompanies={refreshCompanies}
            />

            <Modal open={open} onClose={() => setOpen(false)}>
                <>
                    <CompanyForm
                        onClose={() => setOpen(false)}
                        onSuccess={handleCompanyAdded}
                        onError={handleError}
                    />
                </>
            </Modal>
        </Box>
    );
};

export default AdminCompaniesPage;